import { JobListing } from '../models/listing.model';
import { Action } from '@ngrx/store';
import { Job } from '../models/job.model';
import { Assignment } from '../models/assignment.model';

export enum JobsActionTypes {
  LoadJobs = '[Jobs] All Jobs Requested',
  LoadJobsSuccess = '[Jobs] All Jobs Loaded',
  LoadingJobsFailed = '[Jobs] Loading Jobs Failed',
  ChangeJobValidationState = '[Jobs] Change Step And Validate',
  LoadJob = '[Job] Load Job',
  LoadJobSuccess = '[Job] Load Job Success',
  DeleteJob = '[Job] Delete Job',
  DeleteJobSuccess = '[Job] Delete Job Success',
  SaveJob = '[Job] Save Job',
  SaveJobSuccess = '[Job] Save Job Success',
  JobActionFail = '[Job] Job Action Fail',
  SaveTemplate = '[Template] Save Template',
  SaveTemplateSuccess = '[Template] Save Template Success',
  TemplateActionFail = '[Template] Template Action Fail',
  RequestToLoadJobAssignments = '[Job Assignments] Request to Load Job Assignments',
  LoadJobAssignments = '[Job Assignments] Load Job Assignments',
  LoadJobAssignmentsSuccess = '[Job Assignments] Load Job Assignments Success',
  UpdateJobAssignment = '[Job Assignment] Update Job Assignment',
  UpdateJobAssignmentSuccess = '[Job Assignment] Update Job Assignment Success',
  LoadJobCategories = '[Job Category] Load Job Categories',
  LoadJobCategoriesSuccess = '[Job Category] Load Job CategoriesSuccess',
  LoadJobTitleSuggestions = '[Jobs] All Job Title Suggestions Requested',
  LoadJobTitleSuggestionsSuccess = '[Jobs] All Job Title Suggestions Loaded',
  SetOneWayVideoInterview = '[Job] Set one way video interview',
  PublishJob = '[Job] Publish Job',
  PublishJobSuccess = '[Job] Publish Job Success',
  UnpublishJob = '[Job] Unpublish Job',
  UnpublishJobSuccess = '[Job] Unpublish Job Success',
  CloneJob = '[Job] Clone Job',
  CloneJobSuccess = '[Job] Clone Job Success',
  CloneTemplateAsJob = '[Job] Clone Template As Job',
  CloneTemplateAsJobSuccess = '[Job] Clone Template As Job Success',
  ShowPreview = '[Job] Show job preview after save',
  ShowPreviewSuccess = '[Job] Show job preview after save success',
  SaveCurrentJobState = '[Job] Save current job state',
  Empty = '[Job] Empty',
}

export class LoadJobs implements Action {
  readonly type = JobsActionTypes.LoadJobs;

  constructor(
    public payload: {
      unit_id: number | string;
      is_template?: boolean;
      is_draft?: boolean;
      is_published?: boolean;
    }
  ) {}
}

export class LoadJobsSuccess implements Action {
  readonly type = JobsActionTypes.LoadJobsSuccess;

  constructor(public payload: { jobs: Array<{}> }) {}
}

export class LoadJob implements Action {
  readonly type = JobsActionTypes.LoadJob;

  constructor(public payload: { jobId: string }) {}
}

export class PublishJob implements Action {
  readonly type = JobsActionTypes.PublishJob;

  constructor(public payload: { jobId: number }) {}
}

export class PublishJobSuccess implements Action {
  readonly type = JobsActionTypes.PublishJobSuccess;

  constructor(public payload: { job: Job }) {}
}

export class UnpublishJob implements Action {
  readonly type = JobsActionTypes.UnpublishJob;

  constructor(public payload: { jobId: number }) {}
}

export class UnpublishJobSuccess implements Action {
  readonly type = JobsActionTypes.UnpublishJobSuccess;

  constructor(public payload: { job: Job }) {}
}

export class CloneJob implements Action {
  readonly type = JobsActionTypes.CloneJob;

  constructor(public payload: { jobId: number }) {}
}

export class CloneJobSuccess implements Action {
  readonly type = JobsActionTypes.CloneJobSuccess;

  constructor(public payload: { job: Job }) {}
}

export class CloneTemplateAsJob implements Action {
  readonly type = JobsActionTypes.CloneTemplateAsJob;

  constructor(public payload: { jobId: number }) {}
}

export class CloneTemplateAsJobSuccess implements Action {
  readonly type = JobsActionTypes.CloneTemplateAsJobSuccess;

  constructor(public payload: { job: Job }) {}
}

export class LoadJobSuccess implements Action {
  readonly type = JobsActionTypes.LoadJobSuccess;

  constructor(public payload: { job: Job }) {}
}

export class SaveJob implements Action {
  readonly type = JobsActionTypes.SaveJob;

  constructor(
    public payload: {
      job: Job;
      listing?: JobListing;
      showUpdateNotification?: boolean;
      routeChange?: boolean;
      publish?: boolean;
    }
  ) {}
}

export class SaveJobSuccess implements Action {
  readonly type = JobsActionTypes.SaveJobSuccess;

  constructor(
    public payload: {
      job: Job;
      listing?: JobListing;
      isNew?: boolean;
      showUpdateNotification?: boolean;
      lastUpdated?: Date;
    }
  ) {}
}

export class JobActionFail implements Action {
  readonly type = JobsActionTypes.JobActionFail;

  constructor(public payload: { error: any }) {}
}

export class SaveTemplate implements Action {
  readonly type = JobsActionTypes.SaveTemplate;

  constructor(public payload: { job: Job; listing?: JobListing }) {}
}

export class SaveCurrentJobState implements Action {
  readonly type = JobsActionTypes.SaveCurrentJobState;
}

export class DeleteJob implements Action {
  readonly type = JobsActionTypes.DeleteJob;

  constructor(public payload: { jobId: number; listingId?: number }) {}
}

export class DeleteJobSuccess implements Action {
  readonly type = JobsActionTypes.DeleteJobSuccess;
}

export class SaveTemplateSuccess implements Action {
  readonly type = JobsActionTypes.SaveTemplateSuccess;

  constructor(public payload: { job: Job; listing?: JobListing }) {}
}

export class TemplateActionFail implements Action {
  readonly type = JobsActionTypes.TemplateActionFail;

  constructor(public payload: { error: any }) {}
}

export class LoadingJobsFailed implements Action {
  readonly type = JobsActionTypes.LoadingJobsFailed;

  constructor(public payload: { errors: any }) {}
}

export class ChangeJobValidationState implements Action {
  readonly type = JobsActionTypes.ChangeJobValidationState;

  constructor(public payload: { isValid: boolean }) {}
}

export class LoadJobAssignments implements Action {
  readonly type = JobsActionTypes.LoadJobAssignments;

  constructor(public payload: { jobId: number }) {}
}

export class RequestToLoadJobAssignments implements Action {
  readonly type = JobsActionTypes.RequestToLoadJobAssignments;

  constructor(public payload: { jobId: number }) {}
}

export class LoadJobAssignmentsSuccess implements Action {
  readonly type = JobsActionTypes.LoadJobAssignmentsSuccess;

  constructor(public payload: { jobAssignments: Assignment[] }) {}
}

export class UpdateJobAssignment implements Action {
  readonly type = JobsActionTypes.UpdateJobAssignment;

  constructor(public payload: { assignment: Assignment }) {}
}

export class UpdateJobAssignmentSuccess implements Action {
  readonly type = JobsActionTypes.UpdateJobAssignmentSuccess;

  constructor(public payload: { assignment: Assignment }) {}
}

export class LoadJobCategories implements Action {
  readonly type = JobsActionTypes.LoadJobCategories;
}

export class LoadJobCategoriesSuccess implements Action {
  readonly type = JobsActionTypes.LoadJobCategoriesSuccess;

  constructor(public payload: { categories: any[] }) {}
}

export class LoadJobTitleSuggestions implements Action {
  readonly type = JobsActionTypes.LoadJobTitleSuggestions;

  constructor(public payload: { term: String }) {}
}

export class LoadJobTitleSuggestionsSuccess implements Action {
  readonly type = JobsActionTypes.LoadJobTitleSuggestionsSuccess;

  constructor(public payload: { jobTitleSuggestions: any[] }) {}
}

export class SetOneWayVideoInterview implements Action {
  readonly type = JobsActionTypes.SetOneWayVideoInterview;

  constructor(public payload: { hasVideoInterview: boolean }) {}
}

export class ShowPreview implements Action {
  readonly type = JobsActionTypes.ShowPreview;

  constructor(
    public payload: {
      job: Job;
      listing?: JobListing;
      showUpdateNotification?: boolean;
      lastUpdated?: Date;
    }
  ) {}
}

export class ShowPreviewSuccess implements Action {
  readonly type = JobsActionTypes.ShowPreviewSuccess;

  constructor(
    public payload: {
      job: Job;
      listing?: JobListing;
      isNew?: boolean;
      showUpdateNotification?: boolean;
      lastUpdated?: Date;
    }
  ) {}
}

export class Empty implements Action {
  readonly type = JobsActionTypes.Empty;
}

export type JobsActions =
  | LoadJobs
  | LoadJobsSuccess
  | LoadingJobsFailed
  | ChangeJobValidationState
  | LoadJob
  | LoadJobSuccess
  | JobActionFail
  | SaveJob
  | SaveJobSuccess
  | TemplateActionFail
  | SaveTemplate
  | SaveTemplateSuccess
  | RequestToLoadJobAssignments
  | LoadJobAssignments
  | LoadJobAssignmentsSuccess
  | UpdateJobAssignment
  | UpdateJobAssignmentSuccess
  | LoadJobCategories
  | LoadJobCategoriesSuccess
  | LoadJobTitleSuggestions
  | LoadJobTitleSuggestionsSuccess
  | DeleteJob
  | DeleteJobSuccess
  | SetOneWayVideoInterview
  | CloneJob
  | CloneJobSuccess
  | CloneTemplateAsJob
  | CloneTemplateAsJobSuccess
  | UnpublishJob
  | UnpublishJobSuccess
  | PublishJob
  | PublishJobSuccess
  | ShowPreview
  | ShowPreviewSuccess
  | SaveCurrentJobState
  | Empty;
